import React, { useEffect } from "react";
import { connect } from "react-redux";

import { getTrash } from "../../actions/trashAction";
import Loader from "../common/Loader";
import Header from "./Header";
import { useDelete } from "./hooks/useDelete";
import { useModal } from "./hooks/useModal";
import { useRestore } from "./hooks/useRestore";
import { useSortAttributes } from "./hooks/useSortAttributes";
import { useSortIdeas } from "./hooks/useSortIdeas";
import { useTabs } from "./hooks/useTabs";
import { useTrashAttributes } from "./hooks/useTrashAttributes";
import { useTrashComponents } from "./hooks/useTrashComponents";
import { useTrashIdeas } from "./hooks/useTrashIdeas";
import { useTrashProjects } from "./hooks/useTrashProjects";
import ConfirmationDeleteModal from "./modal/ConfirmationDeleteModal";
import ConfirmationRestoreModal from "./modal/ConfirmationRestoreModal";
import Tabs from "./Tabs";

const Trash = ({ auth, ideas, isLoading, getTrash, components, attributes, projects }) => {
  const { user, status: userStatus } = auth;

  const {
    modal,

    handleOpenDeleteModal,
    handleCloseDeleteModal,

    handleCloseDeleteAllModal,

    handleOpenRestoreModal,
    handleCloseRestoreModal,

    handleCloseRestoreAllModal,
  } = useModal();

  const {
    ideasPicked,
    selectedAll,

    handlePickedIdea,
    handlePickedIdeasAll,
    handleRestoreIdeas,
    handleDeleteIdeas,
  } = useTrashIdeas(ideas);

  const {
    attributesPicked,
    selectedAllAttributes,

    handlePickedAttribute,
    handlePickedAllAttributes,
    handleRestoreAttributes,
    handleDeleteAttributes,
  } = useTrashAttributes(attributes);

  const {
    componentsPicked,
    selectedAllComponents,

    handlePickedComponent,
    handlePickedAllComponents,
    handleRestoreComponents,
    handleDeleteComponents,
  } = useTrashComponents(components);

  const { projectsPicked, handlePickedProject, handleDeleteProjects, handleRestoreProjects } = useTrashProjects(
    getTrash,
    projects,
    handleCloseDeleteAllModal,
    handleCloseRestoreAllModal,
  );

  const { handleSortChangeAttributes, sortAttributes, sortedAttributes, rowsAttributes, setRowsAttributes } =
    useSortAttributes();
  const { handleSortChangeIdeas, sortIdeas, sortedIdeas, rowsIdeas, setRowsIdeas } = useSortIdeas();

  const { activeTab, setActiveTab, getActiveTypeAndSize } = useTabs(
    ideasPicked,
    attributesPicked,
    componentsPicked,
    projectsPicked,
  );

  const { handleDelete } = useDelete(
    getTrash,
    activeTab,
    handleCloseDeleteModal,
    handleDeleteIdeas,
    handleDeleteAttributes,
    handleDeleteComponents,
    handleDeleteProjects,
  );

  const { handleRestore } = useRestore(
    getTrash,
    activeTab,
    handleCloseRestoreModal,
    handleRestoreIdeas,
    handleRestoreAttributes,
    handleRestoreComponents,
    handleRestoreProjects,
  );

  const tabs = [
    { name: "Projects", count: projects?.length ?? 0 },
    { name: "Components", count: components?.length ?? 0 },
    { name: "Attributes", count: attributes?.length ?? 0 },
    { name: "Ideas", count: rowsIdeas?.length ?? 0 },
  ];

  useEffect(() => {
    getTrash();
  }, []);

  //TODO: rewrite this logic
  useEffect(() => {
    ideas.contradictionSolving &&
      setRowsIdeas(
        sortedIdeas([
          ...ideas.contradictionSolving,
          ...ideas.detailsMatrix,
          ...ideas.eureka,
          ...ideas.replacement,
          ...ideas.multiplication,
          ...ideas.subtraction,
        ]),
      );
    attributes && setRowsAttributes(sortedAttributes(attributes));
  }, [ideas.contradictionSolving, attributes]);

  return (
    <div className="admin-panel-wrapper">
      <Header
        showDeleteButton
        showRestoreButton
        handleDelete={handleOpenDeleteModal}
        handleRestore={handleOpenRestoreModal}
      />

      {isLoading ? (
        <Loader />
      ) : (
        <Tabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
          rowsIdeas={rowsIdeas}
          ideasPicked={ideasPicked}
          handlePickedIdea={handlePickedIdea}
          handlePickedIdeasAll={handlePickedIdeasAll}
          selectedAll={selectedAll}
          handleSortChangeIdeas={handleSortChangeIdeas}
          sortIdeas={sortIdeas}
          rowsAttributes={rowsAttributes}
          attributesPicked={attributesPicked}
          handlePickedAttribute={handlePickedAttribute}
          handlePickedAllAttributes={handlePickedAllAttributes}
          selectedAllAttributes={selectedAllAttributes}
          handleSortChangeAttributes={handleSortChangeAttributes}
          sortAttributes={sortAttributes}
          rowsComponents={components}
          componentsPicked={componentsPicked}
          projects={projects}
          projectsPicked={projectsPicked}
          handlePickedProject={handlePickedProject}
          handlePickedComponent={handlePickedComponent}
          handlePickedAllComponents={handlePickedAllComponents}
          selectedAllComponents={selectedAllComponents}
          handleSortChangeComponents={handleSortChangeAttributes}
          sortComponents={sortAttributes}
          userStatus={userStatus}
          userId={user.id}
          getTrash={getTrash}
          userFeatures={userStatus.features || []}
        />
      )}

      {modal.deleteModal && (
        <ConfirmationDeleteModal
          handleCloseDeleteModal={handleCloseDeleteModal}
          handleDelete={handleDelete}
          getActiveTypeAndSize={getActiveTypeAndSize}
        />
      )}

      {modal.restoreModal && (
        <ConfirmationRestoreModal
          handleCloseRestoreModal={handleCloseRestoreModal}
          handleRestore={handleRestore}
          getActiveTypeAndSize={getActiveTypeAndSize}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  ideas: state.trash.ideas,
  isLoading: state.trash.isLoadingTrash,
  components: state.trash.components,
  attributes: state.trash.attributes,
  projects: state.trash.projects,
});

export default connect(mapStateToProps, { getTrash })(Trash);
